import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Navbar from './components/Navbar';
import ApplicantForm from './components/ApplicantForm';
import ZakahCalculator from './components/ZakahCalculator';
import DonateButtons from './components/DonateButtons';
// import FAQs from './components/FAQs';
import ScrollToTopButton from './components/ScrollToTopButton';
import './App.css';
import { AnimatePresence } from 'framer-motion';
import Donate from './components/Donate';

const MainPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top of the page when the component loads
  }, []);

  return (
    <div style={{ backgroundColor: '#0c1a2b', color: '#ffffff', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <div id="applicant-form">
          <ApplicantForm />
        </div>
        <div id="donate-buttons">
        <DonateButtons />
        </div>
        {/* <div id="faqs">
          <FAQs />
        </div> */}
      </div>
      <ScrollToTopButton />
    </div>
  );
};

const App = () => {
  return (
    <AnimatePresence mode="wait">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/main" element={<MainPage />} />
          <Route path="/zakah-calculator" element={<ZakahCalculator />} /> 
          <Route path="/donate/zakah" element={<Donate />} />
          <Route path="/donate/sadaqa" element={<Donate />} />
        </Routes>
      </Router>
    </AnimatePresence>
  );
};

export default App;
